var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 10.2918V8.43695C15.8337 7.78937 15.8337 7.46637 15.7133 7.17504C15.593 6.8845 15.3642 6.65491 14.9058 6.19733L11.1565 2.448C10.7614 2.05295 10.5643 1.85583 10.3189 1.73866C10.2681 1.71426 10.2161 1.69259 10.1629 1.67375C9.90724 1.5835 9.62778 1.5835 9.06966 1.5835C6.5007 1.5835 5.21583 1.5835 4.34578 2.28491C4.1701 2.42657 4.01007 2.58661 3.86841 2.76229C3.16699 3.63391 3.16699 4.9172 3.16699 7.48616V10.2918M10.292 1.97933V2.37516C10.292 4.614 10.292 5.7342 10.9879 6.42929C11.6829 7.12516 12.8032 7.12516 15.042 7.12516H15.4378M8.31282 12.6668V15.8335C8.31282 16.58 8.31283 16.9529 8.54478 17.1849C8.77674 17.4168 9.14962 17.4168 9.89616 17.4168H11.0837M3.16699 12.6668L4.75033 15.0418M4.75033 15.0418L6.33366 17.4168M4.75033 15.0418L6.33366 12.6668M4.75033 15.0418L3.16699 17.4168M15.8337 12.6668H13.8545C13.6445 12.6668 13.4432 12.7502 13.2947 12.8987C13.1462 13.0472 13.0628 13.2485 13.0628 13.4585V14.2502C13.0628 14.4601 13.1462 14.6615 13.2947 14.81C13.4432 14.9584 13.6445 15.0418 13.8545 15.0418H15.042C15.252 15.0418 15.4533 15.1252 15.6018 15.2737C15.7503 15.4222 15.8337 15.6235 15.8337 15.8335V16.6252C15.8337 16.8351 15.7503 17.0365 15.6018 17.185C15.4533 17.3334 15.252 17.4168 15.042 17.4168H13.0628",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls-icon.56a0873474984a2fbabdfaadb7daeb61.svg";
export { ForwardRef as ReactComponent };